import { translateFn } from '../../../../utils/translator.helper';
import { html, TemplateResult } from 'lit';
import { createRows } from '../../utils';
import { BaseSpecificDetailsView } from '../../specificDetailViewByType/baseSpecificDetailsView';
import { FindingDetailsPayload } from '../../findingDetails/types';
import { EASMCountryType } from '../../../artifactsInventoryGrid/types';
import { UNAVAILABLE_DATA } from '../../../types';

export class AsnReportsView extends BaseSpecificDetailsView {
  static getGeneralInfo(findingDetails: FindingDetailsPayload, dependencies: any): TemplateResult {
    const detailsInfo = [
      {
        label: translateFn('ASN country'),
        value: findingDetails.country
          ? this.stringsTranslator.translateEASMCountryType(findingDetails.country as EASMCountryType)
          : UNAVAILABLE_DATA,
      },
      {
        label: translateFn('ASN operator'),
        value: findingDetails.operator,
      },
    ];

    const rows = createRows(detailsInfo, UNAVAILABLE_DATA);

    return html`${rows}`;
  }
}
